// removed by extract-text-webpack-plugin
module.exports = {"calendar":"SimplCalendar__calendar___1qiJz","toToday":"SimplCalendar__toToday___1IzjE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SimplCalendar/SimplCalendar.scss
// module id = 1195
// module chunks = 1